import React from 'react';
import './Notebooks.css';
import ActionButton from '../../ActionButton';
import { Link } from 'react-router-dom';

const Notebooks: React.FC = () => {
    return (
        <section className="notebooks">
            <div className="notebooks-content">
                <h2 className="notebooks-title">Cadernos</h2>
                <p className="notebooks-description">
                    Explore os registros visuais e informativos produzidos pelo projeto Voos.
                    Nossas apostilas e cadernos reúnem fotografias, ilustrações científicas e curiosidades sobre as aves da UFRJ, em materiais pensados para quem deseja conhecer mais sobre as espécies, seus hábitos e ambientes.
                    Nesta página, você pode visualizar e baixar gratuitamente todos os materiais. Uma forma de levar o conhecimento e a beleza das aves para além dos muros da universidade.
                </p>
                <div className="notebooks-button-row">
                    <Link to="/cadernos" style={{ textDecoration: "none" }}>
                    <ActionButton text="Ver Cadernos" color="var(--button-primary)" hoverColor="var(--button-primary-hover)" />
                    </Link>
                </div>
            </div>
</section>
    );
}

export default Notebooks;